<template>
    <v-card class="mt-4">
        <v-card-title class="py-2">
            <span>{{ t("Comments") }}</span>
            <v-spacer />
            <v-btn
                v-if="!newComment"
                color="bal-red"
                dark
                small
                class="px-2"
                style="min-width: 0;"
                @click.stop="handleNewCommentClick"
            >
                <v-icon small>add</v-icon>
            </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-2">
            <v-row v-if="newComment" align="center" no-gutters>
                <v-col>
                    <v-textarea
                        v-model="comment"
                        :label="t('Comment')"
                        class="text-field-item"
                        ref="commentArea"
                        dense
                        rows="2"
                        auto-grow
                        hide-details
                        outlined
                        @keypress.enter.prevent="addNewComment"
                    />
                </v-col>
                <v-col cols="auto" class="ml-2">
                    <v-btn color="bal-red" dark small @click.stop="addNewComment">
                        <v-icon small>check</v-icon>
                    </v-btn>
                    <v-btn small class="ml-1" @click="cancelNewComment">
                        <v-icon small>close</v-icon>
                    </v-btn>
                </v-col>
            </v-row>

            <v-list dense class="pa-0">
                <v-list-item
                    v-for="item in comments"
                    :key="item.id"
                    class="comment-item mb-1 px-2"
                >
                    <v-list-item-content class="py-1">
                        <v-list-item-title class="comment-text">{{ item.comment }}</v-list-item-title>
                        <v-list-item-subtitle class="comment-meta">
                            {{ item.first_name ? item.first_name : "" }} ({{ item.date ? item.date : "" }})
                        </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action class="my-0">
                        <v-btn
                            icon
                            x-small
                            @click="handleDeleteCommentClick(item)"
                            v-if="user.role === 'superadmin' || (item.created_by && item.created_by == user.id)"
                        >
                            <v-icon small color="bal-red">fal fa-trash-alt</v-icon>
                        </v-btn>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item v-if="comments && comments.length === 0" class="px-2">
                    <v-list-item-content class="py-1">
                        <v-list-item-title class="text--secondary">{{ t("No comments found") }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
    name: "analysis-comments-card",
    data() {
        return {
            newComment: false,
            comment: null
        };
    },
    computed: {
        ...mapState("AnalysisStore", ["comments"]),
        ...mapState(["user"])
    },
    mounted() {
        this.fetchComments();
    },
    methods: {
        ...mapActions("AnalysisStore", ["fetchComments", "sendNewComment", "deleteComment"]),
        async addNewComment() {
            if (!this.comment || !this.comment.trim()) return;
            let result = await this.sendNewComment(this.comment);
            if (result.success === 1) {
                this.newComment = false;
                this.comment = null;
            }
        },
        cancelNewComment() {
            this.newComment = false;
            this.comment = null;
        },
        async handleDeleteCommentClick(item) {
            if (confirm(this.t("Are you sure you want to delete this comment?"))) {
                await this.deleteComment(item.id);
            }
        },
        handleNewCommentClick() {
            this.newComment = true;
            this.$nextTick(() => {
                this.$refs.commentArea.focus();
            });
        }
    }
};
</script>

<style scoped>
.comment-item {
    border-radius: 6px;
    background-color: #f5f5f5;
    min-height: 40px;
}

.comment-text {
    white-space: normal;
    font-size: 13px;
}

.comment-meta {
    font-size: 11px;
}
</style>
